module.exports = __webpack_public_path__ + "img/virus.fdac4c0c.png";